import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import {
  fetchInfluencer,
  updateInfluencer,
  fetchFilterOptions,
  fetchPolicies
} from '../actions';

import ParentAccountSearch from '../components/forms/ParentAccountSearch';
import EditableTextField from '../components/forms/EditableTextField';
import MultipleSelectEdit from '../components/forms/MultipleSelectEdit';
import MultiTextEdit from '../components/forms/MultiTextEdit';
import EditablePolicies from '../components/forms/EditablePolicies';
import EditableCollection from '../components/forms/EditableCollection';
import EditableSelectField from '../components/forms/EditableSelectField';
import LoadingOverlay from '../components/LoadingOverlay';

import css from '../components/forms/forms.css';

// Material UI Library
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import Checkbox from 'material-ui/Checkbox';

class EditInfluencer extends Component {

  componentDidMount() {
    this.props.dispatch(fetchInfluencer(this.props.influencerId));

    if (!this.props.isFetching && this.props.socialMedia.get('result').size === 0) {
      this.props.dispatch(fetchFilterOptions());
    }

    if (!this.props.isFetching && this.props.policies.get('result').size === 0) {
      this.props.dispatch(fetchPolicies());
    }

  }

  handleUpdate = (key, newValue) => {
    this.props.dispatch(
      updateInfluencer(this.props.influencerId, {
        influencer: {
          [key]: newValue,
        },
      })
    );
  };

  handleSelectMenu = (key, e, i, newValue) => {
    this.props.dispatch(
      updateInfluencer(this.props.influencerId, {
        influencer: {
          [key]: newValue,
        },
      })
    );
  };

  handleChecked = (property, e, value) => {
    this.handleUpdate(property, value);
  };

  render() {
    if (!this.props.influencer ||
      !this.props.influencer.get('gamePlatforms') ||
      this.props.socialMedia.get('result').size === 0) return <div></div>;

      const styles = {
        checkbox: {
          marginTop: 20,
          marginBottom: 20,
          marginLeft: 20,
          width: 150,
        },
      };

    return (
      <div className={css.root} style={{ position: 'relative' }}>
        <section>
          <EditableTextField
            name="firstName"
            floatingLabelText="First Name"
            fullWidth={true}
            value={this.props.influencer.get('firstName')}
            saveValue={this.handleUpdate.bind(this, 'firstName')}
          />
          <EditableTextField
            name="lastName"
            floatingLabelText="Last Name"
            fullWidth={true}
            value={this.props.influencer.get('lastName')}
            saveValue={this.handleUpdate.bind(this, 'lastName')}
          />
        </section>
        <section>
          <ParentAccountSearch
            className={css.textField}
            fullWidth={true}
            hintText={this.props.influencer.get('collectiveName')}
            updateForm={this.handleUpdate.bind(this, 'collectiveId')}
          />
        </section>
        <h3 className={css.title}>Email Addresses</h3>
        <MultiTextEdit
          name="email"
          fullWidth={true}
          floatingLabelText="Email"
          collection={this.props.influencer.get('emails')}
          saveValue={this.handleUpdate.bind(this, 'emailsAttributes')}
        />
        <Checkbox
          checked={this.props.influencer.get('noBlast')}
          label='No Blast'
          style={styles.checkbox}
          onCheck={this.handleChecked.bind(this, 'noBlast')}
        />
        <section>
          <EditableTextField
            name="phone"
            floatingLabelText="Phone"
            fullWidth={true}
            value={this.props.influencer.get('phone')}
            saveValue={this.handleUpdate.bind(this, 'phone')}
          />
          <EditableTextField
            name="mobile"
            floatingLabelText="Mobile Phone"
            fullWidth={true}
            value={this.props.influencer.get('mobile')}
            saveValue={this.handleUpdate.bind(this, 'mobile')}
          />
          <EditableTextField
            name="fax"
            floatingLabelText="Fax"
            fullWidth={true}
            value={this.props.influencer.get('fax')}
            saveValue={this.handleUpdate.bind(this, 'fax')}
          />
        </section>
        <section>
          <EditableTextField
            name="alias"
            floatingLabelText="Alias"
            fullWidth={true}
            value={this.props.influencer.get('alias')}
            saveValue={this.handleUpdate.bind(this, 'alias')}
          />
          <SelectField
            hintText="Gender"
            value={this.props.influencer.get('gender')}
            onChange={this.handleSelectMenu.bind(this, 'gender')}
            style={{ margin: '0 10px' }}
          >
            <MenuItem value={'female'} primaryText="Female" />
            <MenuItem value={'male'} primaryText="Male" />
            <MenuItem value={'other'} primaryText="Other" />
          </SelectField>
          <EditableTextField
            name="birthdate"
            floatingLabelText="Birthdate"
            type="text"
            fullWidth={true}
            value={this.props.influencer.get('birthdate')}
            saveValue={this.handleUpdate.bind(this, 'birthdate')}
          />
        </section>
        <section>
          <EditableTextField
            name="notes"
            floatingLabelText="Notes"
            type="text"
            fullWidth={true}
            value={this.props.influencer.get('notes')}
            saveValue={this.handleUpdate.bind(this, 'notes')}
          />
        </section>
        <h3 className={css.title}>Primary Address</h3>
        <SelectField
          hintText="Select Primary Address"
          value={this.props.influencer.get('addressId')}
          onChange={this.handleSelectMenu.bind(this, 'addressId')}
          style={{ margin: '0 10px', width: '100%' }}
        >
          {this.props.influencer.get('addresses').map(address =>
            <MenuItem  key={address.get('id')} value={address.get('id')} primaryText={address.get('street1')} />
          )}
        </SelectField>
        <EditableCollection
          name="addressesAttributes"
          collection={this.props.influencer.get('addresses')}
          saveValue={this.handleUpdate.bind(this, 'addressesAttributes')}
          title="Addresses"
          multiLine={true}
        >
          <EditableTextField
            name="street1"
            floatingLabelText="Street Address"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
          <EditableTextField
            name="street2"
            floatingLabelText="Street Address 1"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
          <EditableTextField
            name="city"
            floatingLabelText="City"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
          <EditableTextField
            name="state"
            floatingLabelText="State"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
          <EditableTextField
            name="zip"
            floatingLabelText="Zip"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
        </EditableCollection>
        <h3 className={css.title}>Social Media</h3>
        <EditableCollection
          name="influencerSocialMediaAttributes"
          collection={this.props.influencer.get('influencerSocialMedia')}
          saveValue={this.handleUpdate.bind(this, 'influencerSocialMediaAttributes')}
        >
          <EditableSelectField
            name="socialMediumId"
            hintText="Select Social Media"
            collection={this.props.socialMedia}
          />
          <EditableTextField
            name="userName"
            floatingLabelText="User Name"
            type="text"
            fullWidth={true}
            style={{ flex: 1 }}
          />
          <EditableTextField
            name="viewerCount"
            floatingLabelText="Viewer Count"
            type="number"
            fullWidth={true}
            style={{ flex: 1 }}
          />
        </EditableCollection>
        <h3 className={css.title}>Games</h3>
        <EditableTextField
          name="games"
          floatingLabelText="Primary Games"
          type="text"
          fullWidth={true}
          value={this.props.influencer.get('games')}
          saveValue={this.handleUpdate.bind(this, 'games')}
        />
        <h3 className={css.title}>Gaming Platforms</h3>
        <MultipleSelectEdit
          hintText="Add more platforms."
          name="influencerGamePlatformsAttributes"
          collection={this.props.gamePlatforms}
          relatedId="gamePlatformId"
          selectedIds={this.props.influencer.get('influencerGamePlatforms').map(g => {
            return Map({ id: g.get('id'), joinId: g.get('gamePlatformId') });
          })}
          saveValue={this.handleUpdate.bind(this, 'influencerGamePlatformsAttributes')}
        />
        <h3 className={css.title}>Genres</h3>
        <MultipleSelectEdit
          hintText="Add more genres."
          name="influencerGameGenresAttributes"
          collection={this.props.gameGenres}
          relatedId="gameGenreId"
          selectedIds={this.props.influencer.get('influencerGameGenres').map(g => {
            return Map({ id: g.get('id'), joinId: g.get('gameGenreId') });
          })}
          saveValue={this.handleUpdate.bind(this, 'influencerGameGenresAttributes')}
        />
        <h3 className={css.title}>Interests</h3>
        <MultipleSelectEdit
          hintText="Add more Interests."
          name="influencerInterestsAttributes"
          collection={this.props.interests}
          relatedId="interestId"
          selectedIds={this.props.influencer.get('influencerInterests').map(g => {
            return Map({ id: g.get('id'), joinId: g.get('interestId') });
          })}
          saveValue={this.handleUpdate.bind(this, 'influencerInterestsAttributes')}
        />
        <h3 className={css.title}>Awards</h3>
        <EditableCollection
          name="awardsAttributes"
          collection={this.props.influencer.get('awards')}
          saveValue={this.handleUpdate.bind(this, 'awardsAttributes')}
        >
          <EditableTextField
            name="name"
            floatingLabelText="Award Name"
            type="text"
            fullWidth={true}
            style={{ marginRight: '10px' }}
          />
          <EditableTextField
            name="description"
            floatingLabelText="description"
            type="text"
            fullWidth={true}
            style={{ flexGrow: 1 }}
          />
        </EditableCollection>
        <h3 className={css.title}>Policies</h3>
        <EditableCollection
          name="influencerPoliciesAttributes"
          collection={this.props.influencer.get('influencerPolicies')}
          saveValue={this.handleUpdate.bind(this, 'influencerPoliciesAttributes')}
        >
          <EditableSelectField
            name="policyId"
            hintText="Policy"
            collection={this.props.policies}
          />
          <EditableTextField
            name="rate"
            floatingLabelText="Policy Rate"
            type="text"
            fullWidth={true}
            style={{ flex: 1 }}
          />
        </EditableCollection>
        <LoadingOverlay loading={this.props.isFetching} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    influencer: state.get('influencers')
                          .get('items')
                          .get(`${state.get('location').get('options').get('id')}`),
    influencerId: state.get('location').get('options').get('id'),
    socialMedia: state.get('filterOptions').get('socialMedia'),
    gamePlatforms: state.get('filterOptions').get('gamePlatforms'),
    gameGenres: state.get('filterOptions').get('gameGenres'),
    interests: state.get('filterOptions').get('interests'),
    policies: state.get('policies'),
    isFetching: state.get('influencers').get('isFetching')
                    || state.get('filterOptions').get('isFetching')
                    || state.get('policies').get('isFetching'),
  };
}

export default connect(mapStateToProps)(EditInfluencer);



/** WEBPACK FOOTER **
 ** ./containers/EditInfluencer.js
 **/